import React, { useState } from 'react';
import { BellIcon, MailIcon, SmartphoneIcon } from 'lucide-react';
export function BudgetAlerts() {
  const [alerts, setAlerts] = useState([{
    threshold: 50,
    enabled: true,
    email: true,
    push: true
  }, {
    threshold: 75,
    enabled: true,
    email: true,
    push: true
  }, {
    threshold: 90,
    enabled: true,
    email: true,
    push: true
  }, {
    threshold: 100,
    enabled: true,
    email: true,
    push: true
  }]);
  const toggleAlert = (index, field) => {
    const newAlerts = [...alerts];
    newAlerts[index][field] = !newAlerts[index][field];
    setAlerts(newAlerts);
  };
  return <div className="bg-white rounded-xl shadow-sm p-6" data-id="element-48">
      <div className="flex items-center mb-4" data-id="element-49">
        <BellIcon size={20} className="mr-2 text-green-600" data-id="element-50" />
        <h2 className="text-lg font-semibold" data-id="element-51">Budget Alerts</h2>
      </div>
      <p className="text-sm text-gray-600 mb-4" data-id="element-52">
        Set up notifications when you reach certain budget thresholds
      </p>
      <div className="space-y-3" data-id="element-53">
        {alerts.map((alert, index) => <div key={index} className="border border-gray-200 rounded-lg p-4 hover:border-green-300 transition-colors" data-id="element-54">
            <div className="flex items-center justify-between mb-3" data-id="element-55">
              <div className="flex items-center gap-3" data-id="element-56">
                <label className="relative inline-flex items-center cursor-pointer" data-id="element-57">
                  <input type="checkbox" checked={alert.enabled} onChange={() => toggleAlert(index, 'enabled')} className="sr-only peer" data-id="element-58" />
                  <div className="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-green-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-green-600" data-id="element-59"></div>
                </label>
                <span className="font-medium" data-id="element-60">{alert.threshold}% Used</span>
              </div>
              <span className={`px-2 py-1 rounded text-xs font-medium ${alert.threshold >= 90 ? 'bg-red-100 text-red-700' : alert.threshold >= 75 ? 'bg-yellow-100 text-yellow-700' : 'bg-green-100 text-green-700'}`} data-id="element-61">
                {alert.threshold >= 90 ? 'Critical' : alert.threshold >= 75 ? 'Warning' : 'Info'}
              </span>
            </div>
            {alert.enabled && <div className="flex gap-4 ml-12" data-id="element-62">
                <label className="flex items-center text-sm text-gray-600 cursor-pointer" data-id="element-63">
                  <input type="checkbox" checked={alert.email} onChange={() => toggleAlert(index, 'email')} className="mr-2" data-id="element-64" />
                  <MailIcon size={14} className="mr-1" data-id="element-65" />
                  Email
                </label>
                <label className="flex items-center text-sm text-gray-600 cursor-pointer" data-id="element-66">
                  <input type="checkbox" checked={alert.push} onChange={() => toggleAlert(index, 'push')} className="mr-2" data-id="element-67" />
                  <SmartphoneIcon size={14} className="mr-1" data-id="element-68" />
                  Push
                </label>
              </div>}
          </div>)}
      </div>
      <div className="mt-4 p-3 bg-gray-50 rounded-lg" data-id="element-69">
        <p className="text-sm text-gray-600" data-id="element-70">
          <strong data-id="element-71">Note:</strong> Alerts will be sent when your usage crosses
          these thresholds. You can customize notification preferences for each
          alert level.
        </p>
      </div>
    </div>;
}